
angular.module('tf.directives')

    .directive('passwordValidation',  function() {
        return {
            restrict        :'A',
            link: function (scope, element, attrs) {

                var minLength = 7;

                element.on('input', function(){
                    if (element[0].value.length < minLength) {
                        element[0].setCustomValidity("Password must contain at least " + minLength + " characters");
                        element[0].validity.valid = false;
                    } else {
                        element[0].setCustomValidity("");
                    }
                });

            }
        };
    })
;